import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const showToast = (message, type = 'default', duration) => {
  toast(message, { autoClose: duration, type });
};

export { showToast };
